import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Keep this for the overlay logic
import { Icon } from "@iconify/react";

export const showConfirm = ({ title, message, onConfirm, type = 'danger' }) => {
  
  // Dynamic styling based on whether it's a delete/warning (danger) or a standard edit/action (warning)
  const iconColor = type === 'danger' ? 'text-status-danger' : 'text-status-warning';
  const bgColor = type === 'danger' ? 'bg-status-danger' : 'bg-status-warning';
  const bgLightColor = type === 'danger' ? 'bg-status-danger/10' : 'bg-status-warning/10';
  const iconName = type === 'danger' ? 'solar:trash-bin-trash-bold-duotone' : 'solar:pen-bold-duotone';

  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div 
          dir="rtl" 
          className="bg-bg-secondary border border-border rounded-3xl p-6 shadow-2xl w-full max-w-sm mx-4 animate-in fade-in zoom-in-95 duration-200"
        >
          <div className="flex items-start gap-4">
            
            {/* Alert Icon */}
            <div className={`shrink-0 p-3 ${bgLightColor} ${iconColor} rounded-2xl`}>
              <Icon icon={iconName} className="text-3xl" />
            </div>

            {/* Text Content */}
            <div className="mt-1">
              <h1 className="text-xl font-black text-text-primary mb-1">{title}</h1>
              <p className="text-sm font-bold text-text-secondary leading-relaxed">{message}</p>
            </div>
            
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-3 mt-8">
            <button 
              onClick={onClose} 
              className="px-5 py-2.5 bg-bg-tertiary text-text-secondary hover:bg-border hover:text-text-primary rounded-xl font-bold transition-all"
            >
              إلغاء
            </button>
            <button 
              onClick={() => {
                onConfirm();
                onClose();
              }} 
              className={`px-5 py-2.5 ${bgColor} text-white hover:opacity-80 rounded-xl font-bold transition-all shadow-md flex items-center gap-2`}
            >
              تأكيد
            </button>
          </div>
        </div>
      );
    }
  });
};